module.exports = {
	"multiLanguage": [
		{
			"value": "tw",
			"codes": [
				"zh-hk",
				"zh-sg",
				"zh-tw",
				"zh"
			]
		},
		{
			"value": "en",
			"codes": [
				"en-au",
				"en-bz",
				"en-ca",
				"en-ie",
				"en-jm",
				"en-nz",
				"en-ph",
				"en-za",
				"en-tt",
				"en-gb",
				"en-us",
				"en-zw",
				"en"
			]
		},
		{
			"value": "jp",
			"codes": [
				"ja"
			]
		},
		{
			"value": "cn",
			"codes": [
				"zh-cn"
			]
		},
		{
			"value": "kr",
			"codes": [
				"ko-kr"
			]
		}
	],
	"branchList": [
		"kaohsiung",
		"xinzhuang",
		"hualien"
	],
	"meta": {
		"hualien": {
			"tw": {
				"title": "CHATEAU de CHINE 翰品酒店 - 花蓮",
				"description": "花蓮五星級親子渡假酒店，150坪「歡樂森林」遊戲空間，結合幾米繪本主題房、戶外泳池、遊戲沙坑、翔雲廳自助餐美食饗宴，創造花蓮渡假新美學。官網提供客房介紹、訂房、餐飲及活動優惠等最新消息。",
				"keywords": "花蓮飯店,花蓮住宿,花蓮翰品,翰品花蓮,翰品酒店,環保飯店,節能減碳,樂活,綠建築,生活美學,渡假,飯店訂房,線上訂房,促銷活動,餐飲優惠,花蓮景點,蒙德里安,花蓮酒吧,池畔婚禮,生態工法,green hotel,七星潭,太魯閣,花蓮旅遊,旅宿網",
				"image": "hualien/meta.jpg",
				"author": "25sprout, LLC. 新芽網路有限公司"
			},
			"en": {
				"title": "CHATEAU de CHINE Hualien",
				"description": "//EN 花蓮五星級親子渡假酒店，150坪「歡樂森林」遊戲空間，結合幾米繪本主題房、戶外泳池、遊戲沙坑、翔雲廳自助餐美食饗宴，創造花蓮渡假新美學。官網提供客房介紹、訂房、餐飲及活動優惠等最新消息。",
				"keywords": "//EN 花蓮飯店,花蓮住宿,花蓮翰品,翰品花蓮,翰品酒店,環保飯店,節能減碳,樂活,綠建築,生活美學,渡假,飯店訂房,線上訂房,促銷活動,餐飲優惠,花蓮景點,蒙德里安,花蓮酒吧,池畔婚禮,生態工法,green hotel,七星潭,太魯閣,花蓮旅遊,旅宿網",
				"image": "hualien/meta.jpg",
				"author": "25sprout, LLC. 新芽網路有限公司"
			}
		},
		"kaohsiung": {
			"tw": {
				"title": "CHATEAU de CHINE 翰品酒店 - 高雄 | 加購高鐵車票享優惠",
				"description": "「翰動人心、品味時尚」全新亮相揭開嶄新風貌，似是一座閃耀之星，散放光明於愛河邊上，成為南台灣引領風潮的精品設計酒店。 結合了人文藝術與時尚，精緻客房設計呈現獨特風格，及日式料理、港式飲茶、中華料理等異國美食，翰品高雄為賓客打造完美的入住享受！",
				"keywords": "飯店訂房,線上訂房,促銷活動,餐飲優惠,旅宿網",
				"image": "kaohsiung/meta.jpg",
				"author": "25sprout, LLC. 新芽網路有限公司"
			},
			"en": {
				"title": "CHATEAU de CHINE Kaohsiung",
				"description": "//EN 「翰動人心、品味時尚」全新亮相揭開嶄新風貌，似是一座閃耀之星，散放光明於愛河邊上，成為南台灣引領風潮的精品設計酒店。 結合了人文藝術與時尚，精緻客房設計呈現獨特風格，及日式料理、港式飲茶、中華料理等異國美食，翰品高雄為賓客打造完美的入住享受！",
				"keywords": "//EN 飯店訂房,線上訂房,促銷活動,餐飲優惠,旅宿網",
				"image": "kaohsiung/meta.jpg",
				"author": "25sprout, LLC. 新芽網路有限公司"
			}
		},
		"xinzhuang": {
			"tw": {
				"title": "CHATEAU de CHINE 翰品酒店 - 新莊",
				"description": "極緻的新藝術美學，翰品酒店讓您在新莊遇見法國。翰品酒店是新莊地區令人眼光為之一亮的地標建築，大面落地玻璃的設計帶來了優雅時尚的感覺。",
				"keywords": "",
				"image": "xinzhuang/meta.jpg",
				"author": "25sprout, LLC. 新芽網路有限公司"
			},
			"en": {
				"title": "CHATEAU de CHINE Xinzhuang",
				"description": "",
				"keywords": "",
				"image": "xinzhuang/meta.jpg",
				"author": "25sprout, LLC. 新芽網路有限公司"
			}
		}
	},
	"page": {
		"index": {
			"entry": "index"
		},
		"about": {
			"entry": "about"
		},
		"guests": {
			"entry": "guests"
		},
		"videos": {
			"entry": "videos"
		},
		"media": {
			"entry": "media"
		},
		"article": {
			"entry": "article"
		},
		"rooms": {
			"entry": "rooms"
		},
		"rooms-info": {
			"entry": "rooms-info"
		},
		"restaurants": {
			"entry": "restaurants"
		},
		"restaurants-info": {
			"entry": "restaurants-info"
		},
		"themes": {
			"entry": "themes"
		},
		"themes-info": {
			"entry": "themes-info"
		},
		"facilities": {
			"entry": "facilities"
		},
		"transportation": {
			"entry": "transportation"
		},
		"promotions": {
			"entry": "promotions"
		},
		"schedules": {
			"entry": "schedules"
		},
		"privacy": {
			"entry": "privacy"
		}
	},
	"domain": {
		"demo": {
			"main": {
				"value": "chateau.25demo.com",
				"ssl": true
			},
			"hualien": {
				"value": "hua-chateau.25demo.com",
				"ssl": true
			},
			"xinzhuang": {
				"value": "xin-chateau.25demo.com/",
				"ssl": true
			},
			"kaohsiung": {
				"value": "kao-chateau.25demo.com",
				"ssl": true
			},
			"asset": {
				"value": "chateau.25demo.com/assets",
				"ssl": true
			}
		},
		"production": {
			"main": {
				"value": "www.chateaudechine.com",
				"ssl": true
			},
			"hualien": {
				"value": "hualien.chateaudechine.com",
				"ssl": true
			},
			"xinzhuang": {
				"value": "xinzhuang.chateaudechine.com",
				"ssl": true
			},
			"kaohsiung": {
				"value": "kaohsiung.chateaudechine.com",
				"ssl": true
			},
			"asset": {
				"value": "www.chateaudechine.com/assets",
				"ssl": true
			}
		}
	},
	"port": {
		"webpackServer": 3000,
		"browserSyncServer": 8080,
		"apiProxyServer": 9000,
		"wordingServer": 8000
	},
	"GA": {
		"hualien": "UA-52447155-8",
		"kaohsiung": "UA-52447155-7",
		"xinzhuang": "UA-52447155-10"
	},
	"GTM": {
		"hualien": "GTM-TKF47HG",
		"kaohsiung": "GTM-TQBRF5Z",
		"xinzhuang": "GTM-TN99T7M"
	}
};


//////////////////
// WEBPACK FOOTER
// ./config/website.json
// module id = 99
// module chunks = 0